import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const CustomInput = ({
   label,
   id,
   inputType,
   placeholder,
   onChange,
   errors,
   message,
   name,
   value,
   disabled,
   require,
   containerStyle,
   maxLength,
   uppercase,
   ...rest
}) => {
   const [showPassword, setShowPassword] = useState(false);
   const isPassword = inputType === "password";
   const currentType = isPassword
      ? showPassword
         ? "text"
         : "password"
      : inputType
        ? inputType
        : "text";

   const handleChange = (e) => {
      if (e?.target && typeof e.target.value === "string") {
         if (maxLength && e.target.value.length > maxLength) {
            e.target.value = e.target.value.slice(0, maxLength);
         }
         if (uppercase) {
            e.target.value = e.target.value.toUpperCase();
         }
      }
      if (onChange) {
         onChange(e);
      }
   };

   const handleInput = (e) => {
      if (maxLength && e?.target?.value && e.target.value.length > maxLength) {
         e.target.value = e.target.value.slice(0, maxLength);
      }
   };

   return (
      <div className="form-group" style={containerStyle}>
         {label && (
            <label className="text-capitalize" htmlFor={id}>
               {label}
               {require && <span className="text-danger">*</span>}
            </label>
         )}
         {isPassword ? (
            <div className="input-group">
               <input
                  type={currentType}
                  className="form-control"
                  id={id}
                  placeholder={placeholder}
                  onChange={handleChange}
                  onInput={handleInput}
                  value={value}
                  name={name}
                  maxLength={maxLength ? maxLength : 100}
                  disabled={disabled}
                  {...rest}
               />
               <div
                  className="input-group-append"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
               >
                  <span className="input-group-text">
                     {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </span>
               </div>
            </div>
         ) : (
            <input
               type={currentType}
               className="form-control "
               id={id}
               placeholder={placeholder}
               onChange={handleChange}
               onInput={handleInput}
               value={value}
               name={name}
               maxLength={maxLength ? maxLength : 100}
               disabled={disabled}
               {...rest}
            />
         )}
         {errors && (
            <div className="text-danger" style={{ fontSize: ".8rem" }}>
               {message}
            </div>
         )}
      </div>
   );
};

export default CustomInput;
